module.exports = "https://web-assets.ifttt.com/packs/media/icons-v2/updated-d0854803.svg";